
import { useState } from 'react';

export default function FAQSection() {
    const faqs = [
        {
            question: "¿Cuál es el precio mínimo?",
            answer: "Nuestro precio base comienza desde $40.000 para tatuajes pequeños y simples. El valor final depende del tamaño, detalle, ubicación y artista seleccionado."
        },
        {
            question: "¿Con qué tintas trabajan?",
            answer: "Utilizamos exclusivamente tintas vegetales de alta gama (veganas), hipoalergénicas y certificadas, asegurando la mejor cicatrización y durabilidad del color."
        },
        {
            question: "¿Cómo me preparo para el día de mi sesión?",
            answer: "Descansa bien la noche anterior, come algo ligero antes de venir, hidrátate bien y evita el consumo de alcohol 24 horas antes. Trae ropa cómoda que permita fácil acceso a la zona a tatuar."
        },
        {
            question: "¿Cuántos días post tatuaje puedo hacer deporte?",
            answer: "Recomendamos esperar al menos 3 a 5 días para ejercicio ligero y 2 semanas para deportes de contacto o natación, para evitar infecciones y asegurar una buena curación."
        },
        {
            question: "¿Cuánto tiempo toma hacer el tatuaje?",
            answer: "Depende totalmente del diseño. Un tatuaje pequeño puede tomar 30-60 minutos, mientras que sesiones grandes pueden durar 4-6 horas o requerir múltiples sesiones."
        },
        {
            question: "¿Cuáles son los cuidados posteriores?",
            answer: "Te entregaremos un instructivo detallado. Lo básico: mantenerlo limpio, hidratado con la crema recomendada, no rascar, y evitar sol directo, piscinas y mar durante el proceso de cicatrización."
        },
        {
            question: "¿Cuánto se demora en sanar mi tatuaje?",
            answer: "La cicatrización superficial toma unas 2-3 semanas, pero la piel se regenera completamente en unos 4-6 semanas. Cada cuerpo es diferente."
        },
        {
            question: "¿Se puede exponer un tatuaje al sol?",
            answer: "No durante el proceso de cicatrización (primer mes). Después, siempre debes usar bloqueador solar factor 50+ para mantener los colores vivos y las líneas nítidas."
        }
    ];

    const [openIndex, setOpenIndex] = useState<number | null>(0);

    const toggleFAQ = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section id="faq" className="py-20 bg-gray-50">
            <div className="container mx-auto px-6">
                <div className="text-center mb-16">
                    <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                        Preguntas <span className="text-pink-500">Frecuentes</span>
                    </h2>
                    <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                        Resolvemos tus dudas principales para que vengas tranquila y segura a tu sesión
                    </p>
                </div>

                <div className="max-w-3xl mx-auto space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`bg-white rounded-xl overflow-hidden transition-all duration-300 border ${openIndex === index ? 'border-pink-200 shadow-md' : 'border-gray-200'
                                }`}
                        >
                            <button
                                className="w-full text-left px-6 py-4 flex items-center justify-between focus:outline-none"
                                onClick={() => toggleFAQ(index)}
                            >
                                <span className={`font-bold text-lg ${openIndex === index ? 'text-pink-500' : 'text-gray-800'}`}>
                                    {faq.question}
                                </span>
                                <span className={`flex-shrink-0 ml-4 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${openIndex === index ? 'bg-pink-100 text-pink-500' : 'bg-gray-100 text-gray-400'
                                    }`}>
                                    <i className={`ri-arrow-down-s-line text-xl transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''
                                        }`}></i>
                                </span>
                            </button>

                            <div
                                className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'
                                    }`}
                            >
                                <div className="px-6 pb-6 text-gray-600 text-base leading-relaxed border-t border-gray-100 mt-2 pt-4">
                                    {faq.answer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
